<svg
	width="20px"
	style="flex: 0 0 20px"
	viewBox="0 0 32 32"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<g clip-path="url(#clip0_901_1299)">
			<path
				d="M21.4327 25.6768L26.2927 30.5348C26.6837 30.9258 27.3167 30.9258 27.7067 30.5348L30.5357 27.7068C30.9257 27.3168 30.9257 26.6838 30.5357 26.2928L23.3337 19.0918C23.3337 19.0918 24.9997 15.6558 24.9997 12.9998C24.9997 6.37276 19.6267 0.999756 12.9997 0.999756C6.37269 0.999756 0.999687 6.37276 0.999687 12.9998C0.999687 19.6268 6.37269 24.9998 12.9997 24.9998C16.3067 24.9998 19.2997 23.6628 21.4697 21.4998M7.00009 11.0001H19.0001M7.00009 15.0001H12.0001"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_901_1299"> <rect width="32" height="32" fill="currentColor" /> </clipPath>
		</defs>
	</g>
</svg>
